type Subscription<T> = { [token: number]: (arg: T) => void }

type Unsubscribe = () => void
export default class PubSub<T> {
    subIds: number
    subscriptions: { [key: string]: Subscription<T> }

    constructor() {
        this.subIds = 0
        this.subscriptions = {}
    }

    subscribe(topic: string, fn: (arg: T) => void): Unsubscribe {
        if (!this.subscriptions[topic]) {
            this.subscriptions[topic] = {}
        }
        const token = ++this.subIds

        this.subscriptions[topic][token] = fn

        return () => this.unsubscribe(topic, token)
    }

    publish(topic: string, arg: T): boolean {
        const subs = this.subscriptions[topic]
        if (!subs) {
            return false
        }
        const subscriptions = Object.values(subs)
        if (subscriptions.length === 0) {
            return false
        }

        return subscriptions
            .map((sub) => {
                try {
                    sub(arg)
                    return true
                } catch {
                    return false
                }
            })
            .every((result) => result)
    }

    unsubscribe(topic: string, token?: number): void {
        if (!token) {
            // Delete all subscriptions for the topic
            delete this.subscriptions[topic]
        } else {
            // Delete specific subscription
            this.subscriptions[topic] && delete this.subscriptions[topic][token]
        }
    }
}
